import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MdPaginator, MdSort } from '@angular/material';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { IesHttpClient } from '../../Common/ies-http-client.service';
import { Enum } from '../../utility/enum.enum';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { AdmManageCountryService } from './adm-manage-country.service';

@Component({
  selector: 'app-adm-manage-country',
  templateUrl: './adm-manage-country.component.html',
  styleUrls: ['./adm-manage-country.component.css'],
  providers: [AdmManageCountryService, FeatureFlagService]
})

export class AdmManageCountryComponent implements OnInit, OnDestroy {
  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;
  dataSource: TableDataSource | null;
  httpClient: IesHttpClient;
  countryFilteredOptions: any;
  isSearchDisable: boolean;
  form: FormGroup;
  formControl: any;
  role: string;
  showField: boolean;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  paginationInfo: any;
  displayedColumns = ['name', 'code', 'isRequired', 'unsupportedExamTypes', 'action'];

  private redirect(): void {
    window.location.assign("/ies/internal/manage-countries");
  }

  constructor(private featureFlags: FeatureFlagService, private _admManageCountryService: AdmManageCountryService, httpClient: IesHttpClient,
    private _sharedService: SharedService, public _utility: Utility, public _appGlobal: AppGlobals) {
    this.httpClient = httpClient;
    this.form = new FormGroup({countryControl: new FormControl('')});
    this.formControl = this.form.controls;
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_COUNTRIES_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_COUNTRIES_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    this.paginationInfo = { totalRecords: 0 }; // Set initial value of Totalrecords property
    this.loadSearchFormOptions();
    this.getCountry();
    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort, this.httpClient);
    this.readFormControlValueChanges();
  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }

  getCountry(params?: string) {
    if (!params) params = "";

    this._utility.addLoaderCount();
    this._admManageCountryService.searchCountries(params).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {

        // Preformat certian fields and ensure they're strings for sorting
        response.response.results.forEach(r => {
          r.isRequired = "" + r.isRequired;
          r.unsupportedExamTypes = r.unsupportedExamTypes.map(
            this._utility.getExamTypeDisplay
          ).join(", ") || "None";
        });

        this.paginator.pageIndex = 0;
        this.dataSource.curPage = 2;
        this.dataSubject.next(response.response.results);

        if (response.response.paginationInfo) {
          this.paginationInfo = response.response.paginationInfo;
        }
      })
    }, error => this._utility.onErrorCallback(error));
  }

  readFormControlValueChanges() {
    this.form.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(form => {
        this.isSearchDisable = this._utility.searchDisable(form, [], true);
      });

  }

  loadSearchFormOptions(): void {
    this._utility.addLoaderCount();
    this._sharedService.getComboFieldsData(Enum.Country, (response) => {
      this._sharedService.countryList = response.response;
      this._utility.setDataInComboField('country', null, this.formControl.countryControl, this);
      this._utility.removeLoaderCount();
    });
  }

  onSearchBtnClick() {
    let formValues = this.form.getRawValue();
    let params = ""

    if (formValues.countryControl)
      params = `?id=${formValues.countryControl.id}`;

    this.getCountry(params);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-country/adm-manage-country.component.ts